
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class OrderSourcesGrid extends Serenity.EntityGrid<OrderSourcesRow, any> {
        protected getColumnsKey() { return OrderSourcesColumns.columnsKey; }
        protected getDialogType() { return OrderSourcesDialog; }
        protected getIdProperty() { return OrderSourcesRow.idProperty; }
        protected getInsertPermission() { return OrderSourcesRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderSourcesRow.localTextPrefix; }
        protected getService() { return OrderSourcesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}